import { Component, ElementRef, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { TagsAta } from '../tags-ata.enum';
import { BaseResourceFormDlgComponent, FuncaoService, GlobalService, LoginContabil, ModeloRelatorio } from 'eddydata-lib';
import { ModeloRelatorioService } from '../../modelo-relatorio/service/modelo-relatorio.service';
import { Validators } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'lib-modelo-ata-dlg',
  templateUrl: './modelo-ata-dlg.component.html'
})
export class ModeloAtaDlgComponent extends BaseResourceFormDlgComponent<ModeloRelatorio, LoginContabil> {

  @ViewChild('modelo_') campoModelo: ElementRef;
  @Output() callback: EventEmitter<string> = new EventEmitter();
  @Input() public entidade: ModeloRelatorio;
  public modelo: string;
  public tags: { tag: string, descricao: string }[];

  constructor(
    protected injector: Injector,
    protected funcaoService: FuncaoService,
    protected globalService: GlobalService,
    protected modeloService: ModeloRelatorioService,
  ) {
    super(injector, ModeloRelatorio.converteJson, modeloService, "/modelos-relatorio");
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected criarCamposForm(): void {
    this.entidadeForm = this.fb.group({
      id: [null],
      nome: ['Ata de Sessão Pública', [Validators.required]],
      fixo: [false, [Validators.required]],
      tipo: ['ATA_SESSAO', [Validators.required]],
      modelo: [null, [Validators.required]],
      usuario: [this.login.usuario, [Validators.required]],
      orgao: [this.login.orgao, [Validators.required]],
    });
  }

  protected parametrosExtras(): {} {
    return { relations: 'usuario,orgao' };
  }

  protected afterLoad() {
    if (this.entidade.id) {
      this.modelo = this.entidade.modelo;
      this.entidadeForm.get('modelo').setValue(this.entidade.modelo);
    }

    setTimeout(() => this.campoModelo ? this.campoModelo.nativeElement.focus() : null, 500);
  }

  protected async afterInit(): Promise<void> {
    this.carregarTags();
  }

  protected campoFoco(): ElementRef {
    return this.campoModelo;
  }

  protected beforeSubmit() {
  }

  protected afterSubmit(modelo: ModeloRelatorio) {
    this.sair();
  }

  public sair(): void {
    this.callback.emit(this.modelo);
    $('#dialogModeloAta').modal('hide');
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public carregarTags() {
    this.tags = [
      { tag: 'PROCESSO', descricao: TagsAta.PROCESSO },
      { tag: 'NUMERO', descricao: TagsAta.NUMERO },
      { tag: 'MODALIDADE', descricao: TagsAta.MODALIDADE },
      { tag: 'OBJETO', descricao: TagsAta.OBJETO },
      { tag: 'DATA_JULGAMENTO', descricao: TagsAta.DATA_JULGAMENTO },
      { tag: 'HORA_JULGAMENTO', descricao: TagsAta.HORA_JULGAMENTO },
      { tag: 'SALA', descricao: TagsAta.SALA },
      { tag: 'MEMORIAL', descricao: TagsAta.MEMORIAL },
      { tag: 'HISTORICO', descricao: TagsAta.HISTORICO },
      { tag: 'ASSINATURAS', descricao: TagsAta.ASSINATURAS },
      { tag: 'PROPONENTES', descricao: TagsAta.PROPONENTES },
      { tag: 'QUADRO_LANCES', descricao: TagsAta.QUADRO_LANCES },
      { tag: 'CLASSIFICACAO', descricao: TagsAta.CLASSIFICACAO },
      { tag: 'VENCEDORES', descricao: TagsAta.VENCEDORES },
      { tag: 'COMISSAO_PREGOEIRO', descricao: TagsAta.COMISSAO_PREGOEIRO },
      { tag: 'COMISSAO_MEMBROS', descricao: TagsAta.COMISSAO_MEMBROS },
      { tag: 'OBSERVACAO', descricao: TagsAta.OBSERVACAO },
      { tag: 'RECURSO', descricao: TagsAta.RECURSO },
      { tag: 'PREGOEIRO_EQUIPE_DE_APOIO', descricao: TagsAta.PREGOEIRO_EQUIPE_DE_APOIO },
      { tag: 'CLASSIFICACAO_PROPOSTA_INICIAL', descricao: TagsAta.CLASSIFICACAO_PROPOSTA_INICAL },
    ]
  }

  public incluirTag(tag: string) {
    if (!tag) return;
    this.modelo = this.entidadeForm.get('modelo').value;
    if (!this.modelo) this.modelo = '';

    const pos: number = this.campoModelo.nativeElement.selectionStart;
    this.modelo = `${this.modelo.substring(0, pos)} <${tag}> ${this.modelo.substring(pos)}`

    this.entidadeForm.get('modelo').setValue(this.modelo);
    this.campoModelo.nativeElement.selectionEnd = pos + tag.length + 3;
    setTimeout(() => this.campoModelo ? this.campoModelo.nativeElement.focus() : null, 500);
  }

  public atualizarModelo() {
    this.modelo = this.entidadeForm.get('modelo').value;
  }
}
